import {sub_template, getNewMsg} from "./param"
import { GMX_STATS_DOMAIN } from "config/backend";
import {s} from "./socket"
const socketInstanceNew = socketFun()
function socketFun() {
  // console.log("process.env.=", process.env)
  // let s_instance = new s("ws://10.234.67.79:9999/ws/ws");
  let ws_url = `${process.env.REACT_APP_WS_PREFIX}://${GMX_STATS_DOMAIN}/ws/ws`
  let s_instance = new s(ws_url);
  // let s_instance = new s("wss://gateway.dt-hash-it.com/ws/ws");
  s_instance.doOpen()
  s_instance.on('close', onCloseBind)
  return s_instance
}

function unsubOrSub24Fun(symbol) {
  if (!socketInstanceNew || !socketInstanceNew?.socket) {
    socketInstanceNew = socketFun()
  }
  // 订阅24小时数据
  unsubOrSubFun(symbol, "before24Price")
  return socketInstanceNew
}
function unsubOrSubQuoteFun(symbol) {
  if (!socketInstanceNew || !socketInstanceNew?.socket) {
    socketInstanceNew = socketFun()
  }
  // 订阅和取消上次订阅报价数据
  unsubOrSubFun(symbol, "quote")
  return socketInstanceNew
}
// Subscribe for 24 hours or quote - subscribe, cancel last subscription
function unsubOrSubFun(symbol, type = "quote") {
  if (!symbol) {
    return
  }
  let oldName = localStorage.getItem("selected_symbol_name")
  let oldNames = ""
  if (oldName) {
    oldNames = oldName.toLowerCase()+"usdt"
    oldName = oldName.toLowerCase()+"_usdt"
  }
  let symbolName = symbol.toLowerCase()+"_usdt"
  let symbolNames = symbol.toLowerCase()+"usdt"
  // Cancel the previous subscription
  if (oldName && oldName !== symbolName) {
    let unmsg = getNewMsg(oldNames, 0, "unsub", type)
    // console.log("unsubOrSubFun-unmsg=", unmsg)
    sendMessage(unmsg)
  }
  let msg = getNewMsg(symbolNames, 0, "sub", type)
  // console.log("unsubOrSubFun-msg=", msg)
  sendMessage(msg)
}
// Cancel the current subscription individually
function unsubFun(symbol, type = "before24Price", time = 0) {
  if (!socketInstanceNew || !socketInstanceNew?.socket) {
    socketInstanceNew = socketFun()
  }
  let symbolNames = ""
  if (Array.isArray(symbol)) {
    symbolNames = symbol;
  } else {
    symbolNames = symbol?.toLowerCase()+"usdt"
  }
  // Unsubscribe from 24-hour data
  // let symbolName = symbol.toLowerCase()+"_usdt"
  let unmsg = getNewMsg(symbolNames, time, "unsub", type)
  sendMessage(unmsg)
  // return socketInstanceNew
}
// Subscribe to the current separately
function subFun(symbol, type = "before24Price", time = 0) {
  if (!socketInstanceNew || !socketInstanceNew?.socket) {
    socketInstanceNew = socketFun()
  }
  let symbolNames = ""
  // console.log("typeof symbol=", Array.isArray(symbol))
  if (Array.isArray(symbol)) {
    // symbolNames = symbol.map(x => x?.toLowerCase()+"usdt");
    symbolNames = symbol
    localStorage.setItem("chart_token_options", JSON.stringify(symbolNames))
  } else {
    symbolNames = symbol?.toLowerCase()+"usdt"
  }
  let unmsg = getNewMsg(symbolNames, time, "sub", type)
  sendMessage(unmsg)
}

function subSend() {
  let oldName = localStorage.getItem("selected_symbol_name")
  if (oldName) {
    let oldNames = oldName.toLowerCase()+"usdt"
    oldName = oldName.toLowerCase()+"_usdt"
    let msg = getNewMsg(oldNames, 0, "sub", "before24Price")
    // let msg_quote = getNewMsg(oldNames, 0, "sub", "quote")
    sendMessage(msg)
    let chart_token_options = localStorage.getItem("chart_token_options")
    if (chart_token_options) {
      chart_token_options = JSON.parse(chart_token_options)
      let msg_quote = getNewMsg(chart_token_options, 0, "sub", "quote")
      sendMessage(msg_quote)
    }
  }
  let msg_str = localStorage.getItem("lastSubMsg")
	if (msg_str) {
		sendMessage(msg_str)
	}
}
function onCloseBind(){
	// console.log(' >> : The connection has been disconnected... Reconnecting socketInstanceNew=', socketInstanceNew)
	socketInstanceNew.doOpen()
	socketInstanceNew.on('open', function() {
		// console.log(' >> : Reconnected')
    // Resubscribe to quote data and 24-hour data and candlestick data
		subSend()
	});
}
function sendMessage(data) {
  if (socketInstanceNew.checkOpen()) {
    socketInstanceNew.send(data)
  } else {
    socketInstanceNew.on('open', function() {
      socketInstanceNew.send(data)
    })
  }
}
export {
  subFun,
  unsubFun,
  unsubOrSubQuoteFun,
  unsubOrSub24Fun,
  sendMessage,
  socketInstanceNew
}